import { render, staticRenderFns } from "./GiveBadgeDialog.vue?vue&type=template&id=47618edc&scoped=true"
import script from "./GiveBadgeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GiveBadgeDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GiveBadgeDialog.vue?vue&type=style&index=0&id=47618edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47618edc",
  null
  
)

export default component.exports